







































import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  name: "Version",
  data() {
    return {
      loading: true,
      error: "",
      info: {
        version: "",
        buildDate: "",
        app: "",
      },
    };
  },
  mounted() {
    this.fetchVersion();
  },
  methods: {
    fetchVersion() {
      axios
        .get("/api/version")
        .then((response) => {
          this.info = response.data;
          this.loading = false;
        })
        .catch((err) => {
          this.error = "No se pudo obtener la version";
          this.loading = false;
        });
    },
  },
});
